module.exports = __webpack_public_path__ + "img/lbc-radio.183e7f05.png";